import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'


function ShowMultiDayChefitRefundAmountDailog(props: any) {
    let handleClose = () => {
        props.callback();
    }
    let[refundAmountObject, setRefundAmountObject] = useState<any>(null);
    const refundAmountCalculator = useCallback(() => {
      const totalPrice = Number(
        props?.selectedData?.orderDetailsData?.[props?.selectedData?.orderDetailsData?.length - 1]?.totalPrice
      );
      const totalVisits = Number(
        props?.selectedData?.orderDetailsData?.[props?.selectedData?.orderDetailsData?.length - 1]?.discountCouponData?.maximumUsageLimit
      );
      const noOfRefundedVisits =
        totalVisits -
        Number(
          props?.selectedData?.orderDetailsData?.[props?.selectedData?.orderDetailsData?.length - 1]?.discountCouponData?.totalTimesUsed
        );
      const refundAmount = (totalPrice / totalVisits) * noOfRefundedVisits;
    
      const refundAmountObject = {
        refundAmount,
        noOfRefundedVisits,
        totalPrice,
      };
      setRefundAmountObject(refundAmountObject);
    }, [props?.selectedData?.orderDetailsData]);
    
    useEffect(() => {
      refundAmountCalculator();
    }, [refundAmountCalculator]);
    
    
  return (
    <div>
        <Dialog
        onClose={handleClose}
        open = {props.openRefundAmountTab}
        scroll={"paper"}
        maxWidth="xl"
      >
        <DialogTitle>Refund Amount</DialogTitle>
        <DialogContent>
          <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 1, right: 3 }}> <Close /> </IconButton>
          <Box display = {'felx'} flexDirection = {"column"}>
            <Box><span style={{fontWeight : "bold"}}>Amount to be refunded</span> : {refundAmountObject?.refundAmount}</Box>
            <Box><span style={{fontWeight : "bold"}}>Number of Coupons left in Pack</span> : {refundAmountObject?.noOfRefundedVisits}</Box>
            <Box><span style={{fontWeight : "bold"}}>Total Price of Pack</span> : {refundAmountObject?.totalPrice}</Box>
          </Box>
        </DialogContent>
        <DialogActions style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            color={"error"}
            onClick={() => {
              handleClose();
            }}
            size={"small"}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ShowMultiDayChefitRefundAmountDailog
